import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { workflowsRepo } from '@/constants/providers';

export const useEnableWorkflow = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    workflowsRepo.enableWorkflow(id),
  );
